import NotFound from '../common/components/NotFound';

const NotFoundPage = () => {
    return <NotFound />;
};

export default NotFoundPage;
